import React from 'react';
import PropTypes from 'prop-types';
import { dig } from 'spiceutils';
import { Select } from 'spicecomponents';

/**
 * Select field that can either be None, True, or False.
 * Update appropriate field in CDF according to value change.
 * Field and label are dependent on the type that is passed in, which must be one of the
 * specified values.
 */
class TrueFalseNoneSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: getValueFromProps(props) || '' };
  }

  componentWillReceiveProps(e) {
    this.state.value = getValueFromProps(e);
    this.setState(this.state);
  }

  onChange(value) {
    // Send the update to the appropriate CDF field
    let newVal;
    switch (value) {
      case 'True':
        newVal = true;
        break;
      case 'False':
        newVal = false;
        break;
      default:
        newVal = null;
    }

    this.props.updateCDF(this.props.type, newVal);
  }

  render() {
    // Validate that type was passed in correctly
    if (!this.props.type) throw new Error('TrueFalseNoneSelect component requires a type');
    if (!allowedTypeValues.includes(this.props.type)) {
      throw new Error('TrueFalseNoneSelect type must be either Rebase, ShowMissingValues, or CalculatedMissingValues Adjusted');
    }

    const friendlyName = this.props.type.replace(/([A-Z])/g, ' $1');
    if (dig(this.props.controlList, [this.props.type, 'Visible']) === true) {
      return (
        <div>
          <label htmlFor={this.props.name}>{friendlyName}</label>
          <Select options={selectOptions} value={this.state.value} onChange={(e) => this.onChange(e)} />
        </div>
      );
    }

    return null;
  }
}

const getValueFromProps = (props) => {
  const rawVal = props.cdf[props.type];
  switch (rawVal) {
    case true:
      return 'True';
    case false:
      return 'False';
    default:
      return 'None';
  }
};
const selectOptions = [
  { value: 'None' },
  { value: 'True' },
  { value: 'False' },
];
const allowedTypeValues = [
  'Rebase',
  'ShowMissingValues',
  'CalculatedMissingValues',
  'Adjusted',
];

TrueFalseNoneSelect.propTypes = {
  // Function that updates the CDF
  updateCDF: PropTypes.func.isRequired,
  // CDF that includes the object that this select refers to.
  // eslint-disable-next-line
  cdf: PropTypes.object.isRequired,
  // Name given to the input field
  name: PropTypes.string,
  // Type of SampleThreshold. Required and validated. Used for generating label
  // and passing values onto the CDF.
  type: PropTypes.oneOf(allowedTypeValues).isRequired,
  // Used to determine if the component should be rendered or not
  controlList: PropTypes.object,
};

export default TrueFalseNoneSelect;



// WEBPACK FOOTER //
// ./app/components/FormControls/TrueFalseNoneSelect/index.js